import { Grid, Paper } from "@mui/material";

import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import ThreeComponent from "../../../components/ThreeColumnsComponent";
import { IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO, IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE } from "../../../constants/signalRequestConsts";
import { getEmployeesInMyCharge, getEmployeesToApprove } from "../../../api/s10OrganizationApi";
import { searchInMyChargeEmployeesDocuments, setInMyChargeEmployeeDocumentsReset } from "../../../store/slices/userRequests";
import TableDocuments from "./TableDocuments";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// viewType = All, InMyCharge, ToApprove

const EmployeesDocuments = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [errorMsg, setErrorMsg] = useState<string>("")

    const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
    const [descriptionOne, setDescriptionOne] = useState<string>("")
    const [descriptionTwo, setDescriptionTwo] = useState<string>("")
    const [descriptionThree, setDescriptionThree] = useState<string>("")
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageSizeTwo, setPageSizeTwo] = useState<number>(25)
    const [pageSizeThree, setPageSizeThree] = useState<number>(25)
    const [pageOne, setPageOne] = useState<number>(2)
    const [pageTwo, setPageTwo] = useState<number>(2)
    const [pageThree, setPageThree] = useState<number>(2)
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || !connectionId) {
            return;
        }
        getInitialTablesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, connectionId]);

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableOneRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionOne, pageSizeOne, pageOne, employeesCodes]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableTwoRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionTwo, pageSizeTwo, pageTwo, employeesCodes]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableThreeRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionThree, pageSizeThree, pageThree, employeesCodes]);
    
    const getInitialTablesData = async () => {

        setLoading(true)
        let _employeesCodes =  "";
        dispatch(setInMyChargeEmployeeDocumentsReset(IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE));
        dispatch(setInMyChargeEmployeeDocumentsReset(IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO));
        dispatch(setInMyChargeEmployeeDocumentsReset(IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE));
        setEmployeesCodes(null);
        const finalRuc = rucSelected === "all" ? "" : rucSelected;
        if (viewType === "InMyCharge") {
            const result = await getEmployeesInMyCharge(finalRuc);
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado en el organigrama");
                setLoading(false)
                return;
            }
            _employeesCodes = result?.data.join(",")
        } else if (viewType === "ToApprove") {
            const result = await getEmployeesToApprove();
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado a tu grupo de aprobacion")
                setLoading(false)
                return;
            }
            _employeesCodes = result?.data.join(",")
        }
        setEmployeesCodes(_employeesCodes);
        setLoading(false)
    }

    const tableOneRequest = () => 
        dispatch(searchInMyChargeEmployeesDocuments(
            IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE,
            rucSelected,
            employeesCodes as any,
            1,
            descriptionOne,
            pageSizeOne,
            pageOne,
        ));

    const tableTwoRequest = () => 
        dispatch(searchInMyChargeEmployeesDocuments(
            IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO,
            rucSelected,
            employeesCodes as any,
            2,
            descriptionTwo,
            pageSizeTwo,
            pageTwo,
        ));

    const tableThreeRequest = () => 
        dispatch(searchInMyChargeEmployeesDocuments(
            IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE,
            rucSelected,
            employeesCodes as any,
            0,
            descriptionThree,
            pageSizeThree,
            pageThree,
            
        ));

    const ComponentOne = useCallback(() => (
        <TableDocuments
            requestId={IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE}
            page={pageOne}
            setPage={setPageOne}
            description={descriptionOne}
            setDescription={setDescriptionOne}
            pageSize={pageSizeOne}
            setPageSize={setPageSizeOne}
            loading={loading}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected, loading]);

    const ComponentTwo = useCallback(() => (
        <TableDocuments
            requestId={IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_TWO}
            // hiddenFilterOptions={true}
            page={pageTwo}
            setPage={setPageTwo}
            description={descriptionTwo}
            setDescription={setDescriptionTwo}
            pageSize={pageSizeTwo}
            setPageSize={setPageSizeTwo}
            loading={loading}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected, loading]);
    
    const ComponentThree = useCallback(() => (
        <TableDocuments
            requestId={IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_THREE}
            page={pageThree}
            setPage={setPageThree}
            description={descriptionThree}
            setDescription={setDescriptionThree}
            pageSize={pageSizeThree}
            setPageSize={setPageSizeThree}
            loading={loading}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected, loading]);

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <ThreeComponent
                tabsTitle={["No firmados", "Del presente año", "Histórico"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Paper>
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default EmployeesDocuments;